import { jsx as _jsx } from "react/jsx-runtime";
import { ThemeProvider } from '@seddi/ui-kit';
import log from 'loglevel';
import { createRoot } from 'react-dom/client';
import { ThemeApp } from './styles/theme';
import { configure as configureViewer } from './viewer/configure';
import { App } from './App';
import './index.css';
log.setLevel('info');
configureViewer();
const rootElement = document.getElementById('root');
const root = createRoot(rootElement);
root.render(_jsx(ThemeProvider, { theme: ThemeApp, children: _jsx(App, {}) }));
